<label class="switch">
  <input type="radio" (click)="onRadioChange()" value="{{radioValue}}" name="{{radioName}}" [checked]="radioChecked" [attr.disabled]="radioDisabled === 'true'? true : null">
  <div class="tick"></div>
</label>

<!--
 *  Usage
 * <prcins-round-radio radioName="isNewAddress" radioValue="new" (radioChanged)="addressSelectionChanged($event)"></prcins-round-radio> 
 * <prcins-round-radio radioName="isNewAddress" radioValue="existing" (radioChanged)="addressSelectionChanged($event)"></prcins-round-radio> 
-->